export default {
  "testimonials": [
    {
      extract: "Shaun and Kevin provided a detailed diagnosis of the problems that required rectifying and costing. We found them to have high standards, to be punctual, courteous and professional. We have recommended Turners to friends.",
      content: `
        In May 2015 Turner Roofing had the unenviable task of fixing serious errors to our roof structure, tiling and lead work, which had been made during a property extension. The building contractors  were still on site completing the rest of the build when Turners worked to provide a secure and watertight-roof. Turners extended continual courtesy, consideration and professionalism to these contractors.
        The work included:
        Completely strip and recover the middle 3 roof elevations which adjoin the central gutter area whereby all tiles, ridges, lats and felt etc are removed so as to start again from scratch and ensure the preparations and tile gauging is adequate to ensure the roof works and functions effectively.
        • Strip down and refit sun tunnel.
        • Remove the existing/current lead and ensure the timber underneath is adequate and prepare for new lead work.
        • Re-lead.
        • Re lat and felt
        • Re-tile.
        • Re-bed and point all ridges.
        • Point gables and valleys.
        Shaun and Kevin provided a detailed diagnosis of the problems that required rectifying and costing, this was give verbally and in writing with photographs to support this, my husband was also shown the problems in person. The clarity of detail for the identifiable and potential problems gave us a clear understanding of what was required. Shaun would update us immediately when decisions needed to be made, providing  us with the same level of clear information. We found them to have high standards, to be punctual, courteous and professional. We have recommended Turners to friends.
      `,
      author: `Mr and Mrs Nesom, Bishopthorpe`
    },
    {
      extract: "As a Property Manager for a large estate agents I have used Turner Roofing many times. I have always found their service to be excellent.",
      content: `
        As a Property Manager for a large estate agents I have used Turner Roofing many times. I have always found their service to be excellent. Shaun in particular has been superb. He is able to describe exactly what the issues he has found are and is able to describe clearly how much each stage of the work will cost so that there are no nasty surprises. Their work is of an excellent quality and is always finished on time. I would not hesitate to recommend Turner Roofing to anyone looking for a dependable, reliable and reasonable roofing company in York.
      `,
      author: "Jon McCall"
    },
    {
      extract: "The standard of the work is excellent and they were very professional, I have no hesitation in recommending Turner Roofing.",
      content: `Shaun and Kevin Turner carried out a full reroof to my property, which also included chimney repairs and all lead work. The standard of the work is excellent and they were very professional, keeping me informed at all stages of the work undertaken. They were punctual and the site was left clean and tidy each day.They arranged the scaffolding and all waste was taken away at the completion of the work.

        I have no hesitation in recommending Turner Roofing.`,
      author: "Julie, Main Avenue"
    }
  ],
  "albums": [
    {
      title: "Buckingham Street",
      description: "Before and After re-roof",
      photos: [
        {
          title: "",
          imageUrl: "/workphotos/Buckingham Street York/06F051A2-1D91-4A53-9ABB-71DCE4CC92BA.JPG",
          thumbnailUrl: "./workphotos/Buckingham Street York/06F051A2-1D91-4A53-9ABB-71DCE4CC92BA-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Buckingham Street York/5BC72B06-C5C9-4BE3-95A2-90362331869C.JPG",
          thumbnailUrl: "./workphotos/Buckingham Street York/5BC72B06-C5C9-4BE3-95A2-90362331869C-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Buckingham Street York/91F498C3-23CE-4F2B-ABD0-8C956A4A8DE4.JPG",
          thumbnailUrl: "./workphotos/Buckingham Street York/91F498C3-23CE-4F2B-ABD0-8C956A4A8DE4-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Buckingham Street York/A1A246DE-66EA-4EC0-A103-29960E401A06.JPG",
          thumbnailUrl: "./workphotos/Buckingham Street York/A1A246DE-66EA-4EC0-A103-29960E401A06-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Buckingham Street York/FEB9E30C-EC37-4F3E-9F63-251317400DC3.JPG",
          thumbnailUrl: "./workphotos/Buckingham Street York/FEB9E30C-EC37-4F3E-9F63-251317400DC3-thumb.JPG"
        }
      ]
    },
    {
      title: "Eastbourne Grove",
      description: "Full Re-roof.",
      photos: [
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/509E225C-CAF1-4C4C-808D-06691BFC0F78.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/509E225C-CAF1-4C4C-808D-06691BFC0F78-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/852E8670-02AA-4E28-AC9C-AB216A728FC1.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/852E8670-02AA-4E28-AC9C-AB216A728FC1-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/8CB21E72-A770-49AF-85B4-C1D9943C4840.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/8CB21E72-A770-49AF-85B4-C1D9943C4840-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/B8C02D03-6DC9-44B6-B0EB-B89A5A844582.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/B8C02D03-6DC9-44B6-B0EB-B89A5A844582-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/E79AD275-EA82-4494-B2C1-B66BB942BEF9.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/E79AD275-EA82-4494-B2C1-B66BB942BEF9-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "/workphotos/Eastbourne Grove/FE65EC9E-2DA9-4D27-8D53-37DE1E5FFA77.JPG",
          thumbnailUrl: "./workphotos/Eastbourne Grove/FE65EC9E-2DA9-4D27-8D53-37DE1E5FFA77-thumb.JPG"
        }
      ]
    },
    {
      title: "Malton Avenue",
      description: "Re-roof.",
      photos: [
        {
          title: "/workphotos/Malton Avenue/06FF78E3-CA8B-4D42-9C7E-00BC6AC98583.JPG",
          imageUrl: "/workphotos/Malton Avenue/06FF78E3-CA8B-4D42-9C7E-00BC6AC98583.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/06FF78E3-CA8B-4D42-9C7E-00BC6AC98583-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/3F495B0F-575B-4CF4-899D-26CB688B7CCA.JPG",
          imageUrl: "/workphotos/Malton Avenue/3F495B0F-575B-4CF4-899D-26CB688B7CCA.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/3F495B0F-575B-4CF4-899D-26CB688B7CCA-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/41A949ED-D8EE-4E5C-87A7-5E9A47B5E477.JPG",
          imageUrl: "/workphotos/Malton Avenue/41A949ED-D8EE-4E5C-87A7-5E9A47B5E477.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/41A949ED-D8EE-4E5C-87A7-5E9A47B5E477-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/47328E46-A002-4373-B5F1-388DE9A00808.JPG",
          imageUrl: "/workphotos/Malton Avenue/47328E46-A002-4373-B5F1-388DE9A00808.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/47328E46-A002-4373-B5F1-388DE9A00808-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/802610B5-97BD-4FAC-92E8-10CC96D14951.JPG",
          imageUrl: "/workphotos/Malton Avenue/802610B5-97BD-4FAC-92E8-10CC96D14951.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/802610B5-97BD-4FAC-92E8-10CC96D14951-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/932393AE-E99E-4C8E-8D3C-FBCC94A3ECA6.JPG",
          imageUrl: "/workphotos/Malton Avenue/932393AE-E99E-4C8E-8D3C-FBCC94A3ECA6.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/932393AE-E99E-4C8E-8D3C-FBCC94A3ECA6-thumb.JPG"
        },
        {
          title: "/workphotos/Malton Avenue/EB215ECA-CFA0-485A-AF7F-2D1A8652464C.JPG",
          imageUrl: "/workphotos/Malton Avenue/EB215ECA-CFA0-485A-AF7F-2D1A8652464C.JPG",
          thumbnailUrl: "./workphotos/Malton Avenue/EB215ECA-CFA0-485A-AF7F-2D1A8652464C-thumb.JPG"
        }
      ]
    },
    {
      title: "Trenthome Drive",
      description: "Low roof and lead bay.",
      photos: [
        {
          title: "",
          imageUrl: "./workphotos/Trenthome Drive/1C050619-99B6-4081-BD4F-F68A2C87886F.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/1C050619-99B6-4081-BD4F-F68A2C87886F-thumb.jpeg"
        },
        {
          title: "",
          imageUrl: "./workphotos/Trenthome Drive/2C3B1661-5EBA-4F55-B9C6-130D497BA5E9.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/2C3B1661-5EBA-4F55-B9C6-130D497BA5E9-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "./workphotos/Trenthome Drive/55703184-F4DF-452F-B8D7-7404F3932812.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/55703184-F4DF-452F-B8D7-7404F3932812-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "./workphotos/Trenthome Drive/B437B445-9DE5-4E5E-8EC1-8C7678AF9F5B.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/B437B445-9DE5-4E5E-8EC1-8C7678AF9F5B-thumb.JPG"
        },
        {
          title: "",
          imageUrl: "./workphotos/Trenthome Drive/C4241BA8-D427-4A0B-AD5D-132F32584177.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/C4241BA8-D427-4A0B-AD5D-132F32584177-thumb.JPG"
        },
        {
          title: "/workphotos/Trenthome Drive/7137BCD6-570F-408D-BA92-BE03B61AC92A.JPG",
          imageUrl: "/workphotos/Trenthome Drive/7137BCD6-570F-408D-BA92-BE03B61AC92A.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/7137BCD6-570F-408D-BA92-BE03B61AC92A-thumb.JPG"
        },
        {
          title: "/workphotos/Trenthome Drive/9277B4F7-68FF-4F0C-88ED-6D780599D609.JPG",
          imageUrl: "/workphotos/Trenthome Drive/9277B4F7-68FF-4F0C-88ED-6D780599D609.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/9277B4F7-68FF-4F0C-88ED-6D780599D609-thumb.JPG"
        },
        {
          title: "/workphotos/Trenthome Drive/D954F9EA-A7BE-4030-A198-D461B228BDC4.JPG",
          imageUrl: "/workphotos/Trenthome Drive/D954F9EA-A7BE-4030-A198-D461B228BDC4.JPG",
          thumbnailUrl: "./workphotos/Trenthome Drive/D954F9EA-A7BE-4030-A198-D461B228BDC4-thumb.JPG"
        },
        {
          title: "/workphotos/Trenthome Drive/FullSizeRender.jpg",
          imageUrl: "/workphotos/Trenthome Drive/FullSizeRender.jpg",
          thumbnailUrl: "./workphotos/Trenthome Drive/FullSizeRender-thumb.jpg"
        }
      ]
    },
    {
      title: "Elden St",
      description: "",
      photos: [
        {
          title: "Elden St 024",
          imageUrl: "/workphotos/Elden St/work pics 024.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 024-thumb.jpg"
        },
        {
          title: "Elden St 025",
          imageUrl: "/workphotos/Elden St/work pics 025.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 025-thumb.jpg"
        },
        {
          title: "Elden St 027",
          imageUrl: "/workphotos/Elden St/work pics 027.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 027-thumb.jpg"
        },
        {
          title: "Elden St 028",
          imageUrl: "/workphotos/Elden St/work pics 028.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 028-thumb.jpg"
        },
        {
          title: "Elden St 039",
          imageUrl: "/workphotos/Elden St/work pics 039.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 039-thumb.jpg"
        },
        {
          title: "Elden St 040",
          imageUrl: "/workphotos/Elden St/work pics 040.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 040-thumb.jpg"
        },
        {
          title: "Elden St 041",
          imageUrl: "/workphotos/Elden St/work pics 041.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 041-thumb.jpg"
        },
        {
          title: "Elden St 042",
          imageUrl: "/workphotos/Elden St/work pics 042.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 042-thumb.jpg"
        },
        {
          title: "Elden St 043",
          imageUrl: "/workphotos/Elden St/work pics 043.jpg",
          thumbnailUrl: "/workphotos/Elden St/work pics 043-thumb.jpg"
        }
      ]
    },
    {
      title: "Garfield Terrace Before and After",
      description: "",
      photos: [
        {
          title: "Garfield Terrace After",
          imageUrl: "/workphotos/Garfield Terrace Before and After/after.jpg",
          thumbnailUrl: "/workphotos/Garfield Terrace Before and After/after-thumb.jpg"
        },
        {
          title: "Garfield Terrace After 2",
          imageUrl: "/workphotos/Garfield Terrace Before and After/after1.jpg",
          thumbnailUrl: "/workphotos/Garfield Terrace Before and After/after1-thumb.jpg"
        },
        {
          title: "Garfield Terrace Before",
          imageUrl: "/workphotos/Garfield Terrace Before and After/before.jpg",
          thumbnailUrl: "/workphotos/Garfield Terrace Before and After/before-thumb.jpg"
        },
        {
          title: "Garfield Terrace Before 2",
          imageUrl: "/workphotos/Garfield Terrace Before and After/before1.jpg",
          thumbnailUrl: "/workphotos/Garfield Terrace Before and After/before1-thumb.jpg"
        }
      ]
    },
    {
      title: "Roslyn St Pointing",
      description: "",
      photos: [
        {
          title: "Roslyn St Pointing pointing e",
          imageUrl: "/workphotos/Roslyn St Pointing/pointing e.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/pointing e-thumb.jpg"
        },
        {
          title: "Roslyn St Pointing pointing",
          imageUrl: "/workphotos/Roslyn St Pointing/pointing.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/pointing-thumb.jpg"
        },
        {
          title: "Roslyn St Pointing work pics 057",
          imageUrl: "/workphotos/Roslyn St Pointing/work pics 057.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/work pics 057-thumb.jpg"
        },
        {
          title: "Roslyn St Pointing work pics 064",
          imageUrl: "/workphotos/Roslyn St Pointing/work pics 064.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/work pics 064-thumb.jpg"
        },
        {
          title: "Roslyn St Pointing work pics 065",
          imageUrl: "/workphotos/Roslyn St Pointing/work pics 065.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/work pics 065-thumb.jpg"
        },
        {
          title: "Roslyn St Pointing work pics 066",
          imageUrl: "/workphotos/Roslyn St Pointing/work pics 066.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Pointing/work pics 066-thumb.jpg"
        }
      ]
    },
    {
      title: "Roslyn St Roof",
      description: "",
      photos: [
        {
          title: "Roslyn St Roof work pics 059",
          imageUrl: "/workphotos/Roslyn St Roof/work pics 059.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Roof/work pics 059-thumb.jpg"
        },
        {
          title: "Roslyn St Roof work pics 060",
          imageUrl: "/workphotos/Roslyn St Roof/work pics 060.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Roof/work pics 060-thumb.jpg"
        },
        {
          title: "Roslyn St Roof work pics 061",
          imageUrl: "/workphotos/Roslyn St Roof/work pics 061.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Roof/work pics 061-thumb.jpg"
        },
        {
          title: "Roslyn St Roof work pics 062",
          imageUrl: "/workphotos/Roslyn St Roof/work pics 062.jpg",
          thumbnailUrl: "/workphotos/Roslyn St Roof/work pics 062-thumb.jpg"
        }
      ]
    },
    {
      title: "Shipton",
      description: "",
      photos: [
        {
          title: "Shipton work pics 013",
          imageUrl: "/workphotos/Shipton/work pics 013.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 013-thumb.jpg"
        },
        {
          title: "Shipton work pics 014",
          imageUrl: "/workphotos/Shipton/work pics 014.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 014-thumb.jpg"
        },
        {
          title: "Shipton work pics 015",
          imageUrl: "/workphotos/Shipton/work pics 015.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 015-thumb.jpg"
        },
        {
          title: "Shipton work pics 016",
          imageUrl: "/workphotos/Shipton/work pics 016.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 016-thumb.jpg"
        },
        {
          title: "Shipton work pics 017",
          imageUrl: "/workphotos/Shipton/work pics 017.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 017-thumb.jpg"
        },
        {
          title: "Shipton work pics 018",
          imageUrl: "/workphotos/Shipton/work pics 018.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 018-thumb.jpg"
        },
        {
          title: "Shipton work pics 019",
          imageUrl: "/workphotos/Shipton/work pics 019.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 019-thumb.jpg"
        },
        {
          title: "Shipton work pics 020",
          imageUrl: "/workphotos/Shipton/work pics 020.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 020-thumb.jpg"
        },
        {
          title: "Shipton work pics 021",
          imageUrl: "/workphotos/Shipton/work pics 021.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 021-thumb.jpg"
        },
        {
          title: "Shipton work pics 029",
          imageUrl: "/workphotos/Shipton/work pics 029.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 029-thumb.jpg"
        },
        {
          title: "Shipton work pics 030",
          imageUrl: "/workphotos/Shipton/work pics 030.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 030-thumb.jpg"
        },
        {
          title: "Shipton work pics 031",
          imageUrl: "/workphotos/Shipton/work pics 031.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 031-thumb.jpg"
        },
        {
          title: "Shipton work pics 032",
          imageUrl: "/workphotos/Shipton/work pics 032.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 032-thumb.jpg"
        },
        {
          title: "Shipton work pics 033",
          imageUrl: "/workphotos/Shipton/work pics 033.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 033-thumb.jpg"
        },
        {
          title: "Shipton work pics 034",
          imageUrl: "/workphotos/Shipton/work pics 034.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 034-thumb.jpg"
        },
        {
          title: "Shipton work pics 035",
          imageUrl: "/workphotos/Shipton/work pics 035.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 035-thumb.jpg"
        },
        {
          title: "Shipton work pics 036",
          imageUrl: "/workphotos/Shipton/work pics 036.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 036-thumb.jpg"
        },
        {
          title: "Shipton work pics 037",
          imageUrl: "/workphotos/Shipton/work pics 037.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 037-thumb.jpg"
        },
        {
          title: "Shipton work pics 038",
          imageUrl: "/workphotos/Shipton/work pics 038.jpg",
          thumbnailUrl: "/workphotos/Shipton/work pics 038-thumb.jpg"
        }
      ]
    }
  ]
};


/** WEBPACK FOOTER **
 ** ./src/data.js
 **/